import { render, staticRenderFns } from "./EventSectionForm.vue?vue&type=template&id=ec1965b4"
import script from "./EventSectionForm.vue?vue&type=script&lang=js"
export * from "./EventSectionForm.vue?vue&type=script&lang=js"
import style0 from "./EventSectionForm.vue?vue&type=style&index=0&id=ec1965b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports